import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router";
import { Divider, Empty, message, Select, Spin } from "antd";
import {
  apiChangeRegistrationStatus,
  apiGetRegistrationDetail,
  apiGetRegistrationList,
} from "services/dashboardService";
import CommonDivWidget from "components/CommonDivWidget/CommonDivWidget";
import "./Dashboard.css";
import ClubTable from "./ClubTable/ClubTable";
import ClubBoxWidget from "components/ClubBoxWidget/ClubBoxWidget";
import { ROUTE_HOME_SETTING } from "navigation/CONSTANTS";
const { Option } = Select;
const Dashboard = (props) => {
  const history = useHistory();
  const userDataStore = useSelector((x) => x.userDataStore);
  const appDataStore = useSelector((x) => x.appDataStore);
  const [isBusy, setIsBusy] = useState(false);

  const [regInfoList, setRegInfoList] = useState([]);
  const [userList, setUserList] = useState([]);

  useEffect(() => {
    if (appDataStore.club != undefined) {
      fetchAllRegistrationsWithDetails(appDataStore.club.id);
    } else {
      setRegInfoList([]);
      setUserList([]);
    }
  }, [appDataStore.club]);

  // Fetch all registrations, then fetch details for each
  const fetchAllRegistrationsWithDetails = async (clubId) => {
    setIsBusy(true);
    try {
      const params = new URLSearchParams();
      params.append("token", userDataStore.token);
      params.append("club_id", clubId);
      const registrations = await apiGetRegistrationList(params);
      console.log("Registrations:", registrations);
      // Fetch details for each registration in parallel
      const detailPromises = registrations.map(async (reg) => {
        const detailParams = new URLSearchParams();
        detailParams.append("token", userDataStore.token);
        detailParams.append("registration_id", reg.ID);
        detailParams.append("sport_type", userDataStore?.sport_type);
        const detailRes = await apiGetRegistrationDetail(detailParams);
        console.log("Detail response:", detailRes);
        let tmpList = [];
        tmpList = [...tmpList, detailRes.info];
        return {
          ...reg,
          balance: detailRes.info.balance,
          count: detailRes.info.count,
          discount: detailRes.info.discount,
          fee: detailRes.info.fee,
          name: detailRes.info.name,
          net_fee: detailRes.info.net_fee,
          refund: detailRes.info.refund,
          status: detailRes.info.status,
          transfer: detailRes.info.transfer,
        };
      });
      const regListWithDetails = await Promise.all(detailPromises);
      setRegInfoList(regListWithDetails);
      setIsBusy(false);
    } catch (err) {
      setIsBusy(false);
      message.error(err);
    }
  };

  const onChangeStatus = (info, newStatus) => {
    let tmpList = [...regInfoList];
    let tmpIndex = tmpList.findIndex((x) => x.name == info.name);
    tmpList[tmpIndex].status = newStatus;

    const statusValue = newStatus == "OPEN" ? 1 : newStatus == "HIDE" ? 2 : 0;
    const params = new URLSearchParams();
    params.append("token", userDataStore.token);
    params.append("registration_id", tmpList[tmpIndex].ID);
    params.append("status", statusValue);
    setIsBusy(true);
    apiChangeRegistrationStatus(params)
      .then((res) => {
        setRegInfoList(tmpList);
        setIsBusy(false);
      })
      .catch((err) => {
        setIsBusy(false);
        message.error(err);
      });
  };
  const onDetail = (record) => {
    // Navigate to Home Setting for the clicked registration record
    const targetId = record?.ID;
    if (targetId) {
      history.push(ROUTE_HOME_SETTING + "/" + targetId);
    }
  };
  return (
    <CommonDivWidget>
      <Spin spinning={isBusy}>
        <div className="dashboard-page">
          <ClubBoxWidget newReg={true} disableRegistrationSelect />
          <div style={{ paddingLeft: 10, paddingRight: 10 }}>
            <Divider
              style={{ borderTop: "4px solid var(--mainColor)" }}
            ></Divider>
            <ClubTable
              dataList={regInfoList}
              onChangeStatus={onChangeStatus}
              onDetail={onDetail}
            />
            {/* <RegFormTable dataList={userList} /> */}
          </div>
        </div>
      </Spin>
    </CommonDivWidget>
  );
};

export default Dashboard;
